import {
  getColorScheme
} from "./chunk-C6ESTM3N.mjs";
import {
  useSmallScreen
} from "./chunk-ALXBK6NV.mjs";

// src/internal/components/header/header.tsx
import * as React from "react";
import { Menu as MenuIcon } from "@mui/icons-material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { getValidChildren } from "@clara/react-utils";
import { Flex, Logo } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
function Header(props) {
  const {
    children,
    variant = "customer",
    hasMultientities,
    username,
    onUserClick,
    onToggle,
    ...rest
  } = props;
  const theme = useTheme();
  const sm = useSmallScreen();
  const candidate = variant === "candidate";
  const customer = variant === "customer";
  const validChildren = getValidChildren(children);
  const clones = validChildren.filter(
    (child) => {
      var _a;
      return ((_a = child.type) == null ? void 0 : _a.id) === "HeaderElement";
    }
  );
  const variants = [
    "account",
    "actions",
    "navigation",
    "title",
    "tools",
    "banner"
  ];
  const { account, actions, navigation, title, tools, banner } = variants.reduce((acc, variant2) => {
    const element = clones.find(
      (child) => {
        var _a;
        return ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.variant) === variant2;
      }
    );
    return { ...acc, [variant2]: element };
  }, {});
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(
      Flex,
      {
        sx: (theme2) => ({
          minHeight: theme2.spacing(7),
          ...getColorScheme(theme2)
        }),
        ...rest,
        children: /* @__PURE__ */ jsxs(
          Flex,
          {
            grow: 1,
            alignItems: "center",
            py: 1,
            px: 3,
            justify: "space-between",
            children: [
              candidate && /* @__PURE__ */ jsxs(
                Stack,
                {
                  spacing: 3,
                  alignItems: "center",
                  direction: "row",
                  divider: hasMultientities && /* @__PURE__ */ jsx(Divider, { orientation: "vertical", flexItem: true }),
                  children: [
                    /* @__PURE__ */ jsxs(
                      Stack,
                      {
                        direction: "row",
                        spacing: 1,
                        sx: (theme2) => ({
                          alignItems: "center",
                          minWidth: theme2.spacing(29)
                        }),
                        children: [
                          /* @__PURE__ */ jsx(
                            Logo,
                            {
                              href: "/",
                              ...sm && {
                                icon: "logotype",
                                width: theme.spacing(10),
                                height: theme.spacing(3.75)
                              },
                              ...!sm && {
                                icon: "monogram",
                                width: theme.spacing(3),
                                height: theme.spacing(3)
                              }
                            }
                          ),
                          !sm && /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", fontWeight: 600, children: title })
                        ]
                      }
                    ),
                    !sm && account
                  ]
                }
              ),
              customer && sm && /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 0, alignItems: "center", children: [
                /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: onToggle, children: /* @__PURE__ */ jsx(MenuIcon, {}) }),
                /* @__PURE__ */ jsx(
                  Logo,
                  {
                    ...{
                      href: "/",
                      icon: "logotype",
                      width: theme.spacing(10),
                      height: theme.spacing(3.75)
                    }
                  }
                )
              ] }),
              customer && !sm && account,
              tools
            ]
          }
        )
      }
    ),
    banner,
    /* @__PURE__ */ jsxs(Stack, { children: [
      /* @__PURE__ */ jsx(Container, { maxWidth: false, children: /* @__PURE__ */ jsxs(
        Stack,
        {
          alignItems: "center",
          direction: "row",
          justifyContent: (!title && actions || candidate && !sm) && "flex-end" || title && actions && "space-between",
          children: [
            (customer || candidate && sm) && title && /* @__PURE__ */ jsx(Typography, { mt: 3, mb: 1, variant: "h2", children: title }),
            actions && React.cloneElement(actions, {
              component: Stack,
              direction: "row",
              spacing: 1,
              py: 2
            })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Container, { maxWidth: false, children: navigation })
    ] })
  ] });
}

export {
  Header
};
